import { FunctionFactory } from 'survey-core';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';

const injuriesSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{injuriesIcon}</div>
  <div class="splash-header">
    <h1>{injuriesTitle}</h1>
    <div class="quote">
      {injuriesQuote}
    </div>
  </div>
</div>`;

const injuriesSplashExpression = {
  name: "injuriesQuote",
  expression: "renderInjuriesQuote({injuries})",
};

function renderInjuriesQuote(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return tSurvey("splash.injuries.quote.none");
  } 
  return tSurvey("splash.injuries.quote.injured");
}

FunctionFactory.Instance.register("renderInjuriesQuote", renderInjuriesQuote);

function renderInjuriesIcon(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return `💪`;
  } 
  return `🛠️`;
}

FunctionFactory.Instance.register("renderInjuriesIcon", renderInjuriesIcon);

const injuriesSplashIconExpression = {
  name: "injuriesIcon",
  expression: "renderInjuriesIcon({injuries})",
};

function renderInjuriesTitle(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return tSurvey("splash.injuries.title.none");
  } 
  return tSurvey("splash.injuries.title.injured");
}

FunctionFactory.Instance.register("renderInjuriesTitle", renderInjuriesTitle);

const injuriesSplashTitleExpression = {
  name: "injuriesTitle",
  expression: "renderInjuriesTitle({injuries})",
};

const injuriesSplashElement = {
  name: 'injuries-splash',
  type: 'html',
  html: injuriesSplashHtml,
}

const InjuriesSplashHeader = makeSplashHeader("splash.headers.injuries");

export {
  injuriesSplashElement,
  injuriesSplashExpression,
  InjuriesSplashHeader,
  injuriesSplashIconExpression,
  injuriesSplashTitleExpression,
}
